// my-theme.ts
import { em } from "polished";
import { DefaultTheme } from "styled-components";
const black = "#242424";
const blue = "#0050ff";
const bgGlobal = "#131924";
const cyan = "#00D4FF";
const cyanDark = "#00A8CC";
const darkPink = "#e90052";
const fantasy = "#00ff87";
const greyLight = "#dadada";
const greyLight4 = "#eeeeee";
const grey24 = "rgba(129, 147, 184, 0.24)";
const lightBlue = "#00aac2";
const primary = "#131924";
const yellow = "#ffd600";
const orange = "#ffa500";
const whiteGrey = "#e8e8ea";
const white1 = "rgba(255, 255, 255, 1)";
const white4 = "rgba(255, 255, 255, 0.04)";
const white5 = "rgba(255, 255, 255, 0.05)";
const white8 = "rgba(255, 255, 255, 0.08)";
const white9 = "rgba(255, 255, 255, 0.90)";
const white16 = "rgba(255, 255, 255, 0.16)";
const green = "#84ff00";
const red = "#fe0901";
const white20 = "rgba(255, 255, 255, 0.20);";
const mobileNavBg = "#2d394d";

const theme: DefaultTheme = {
  borders: [
    `0.5px solid ${white16}`,
    `1px solid ${white5}`,
    `1px solid ${white16}`,
    `0.5px solid ${white20}`,
    `3px solid ${darkPink}`,
    `1px solid ${white9}`,
  ],
  breakpoints: [
    em("400px"),
    em("610px"),
    em("700px"),
    em("900px"),
    em("1024px"),
    em("1220px"),
  ],
  colors: {
    black,
    blue,
    blueDark: "#0037af",
    bgGlobal,
    cyan,
    cyanDark,
    mobileNavBg,
    darkPink,
    difficulties: {
      1: {
        bg: "#257d5a",
        color: "white",
      },
      2: {
        bg: "#00ff86",
        color: "black",
      },
      3: {
        bg: "#ebebe4",
        color: "black",
      },
      4: {
        bg: "#ff005a",
        color: "white",
      },
      5: {
        bg: "#861d46",
        color: "white",
      },
    },
    elementStatus: {
      0: {
        bg: "#c0020d",
        color: "white",
      },
      25: {
        bg: "#d44401",
        color: "white",
      },
      50: {
        bg: "#ffab1b",
        color: black,
      },
      75: {
        bg: "#ffe65b",
        color: black,
      },
    },
    elementTypes: {
      1: {
        bg: yellow,
        color: primary,
      },
      2: {
        bg: fantasy,
        color: primary,
      },
      3: {
        bg: blue,
        color: primary,
      },
      4: {
        bg: darkPink,
        color: "white",
      },
    },
    error: "#e02200",
    fantasy,
    green,
    greenDark: "#93e400",
    grey: "#e7e7e7",
    grey24,
    greyDark: "#535353",
    greyLight,
    greyLight2: "#c9ced6",
    greyLight3: "#f7f7f7",
    greyLight4,
    pink: "#ff2882",
    primary,
    greyDarker1: "#e5e5e5",
    greyDarker2: "#e0e0e0",
    greyDarker3: "#6E6E6E",
    blueDarker1: "#3069a5",
    blueDarker2: "#004986",
    blueDarker3: "#14253c",
    blueDarker4: "#161619",
    blueDarker5: "#2b3a5b",
    red,
    secondary: lightBlue,
    social: {
      facebook: {
        bg: "#3b5998",
        color: "white",
      },
      twitter: {
        bg: "#00aced",
        color: "white",
      },
      google: {
        bg: "white",
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
    success: "#14af4f",
    tertiary: "#d2eff9",
    text: "#fff",
    orange,
    white: "#fff",
    whiteBlue: "#f2f9fa",
    whiteGrey,
    white1,
    white4,
    white5,
    white8,
    white9,
    white16,
    white20,
    yellow,
    yellowLight: "#fff59c",
  },
  backdropFilters: { default: "blur(60px)" },
  fontSizes: [
    "1.2rem",
    "1.3rem",
    "1.4rem",
    "1.6rem",
    "1.8rem",
    "2rem",
    "2.4rem",
    "2.6rem",
    "3rem",
    "3.4rem",
  ],
  fonts: {
    base: '"ExpoArabic Medium", Helvetica, Arial, sans-serif',
    impact: '"ExpoArabic SemiBold", Helvetica, Arial, sans-serif',
    light: '"ExpoArabic Light", Helvetica, Arial, sans-serif',
    bold: '"ExpoArabic Bold", Helvetica, Arial, sans-serif',
    book: '"ExpoArabic Book", Helvetica, Arial, sans-serif',
  },
  radii: ["2px", "5px", "10px", "15px", "50px"],
  space: ["0", "0.5rem", "1rem", "1.5rem", "2rem", "2.5rem", "3rem"],
  zIndex: {
    clientMenu: 7000,
    dialog: 9000,
    menu: 6000,
    overlay: 8000,
    select: {
      select: 50,
      wrap: 40,
    },
  },
};

export default theme;
